import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUser(id) {
  const url = 'api/user/' + id + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, public profiles
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

// this is used to check if email is taken when registering
function getUserByEmail(email) {
  return axios({
    method: 'get',
    url: '/api/user/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth
    },
    params: {
      email,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

// this is used to check if username is taken when registering
function getUserByUsername(username) {
  return axios({
    method: 'get',
    url: '/api/user/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth
    },
    params: {
      username,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

// this is used for public profile pages
function getUserByUsernameDepth(username) {
  return axios({
    method: 'get',
    url: '/api/userlogin/' + username + '/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function registerUser(user) {
  return axios({
    method: 'post',
    url: '/api/user/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    data: {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      username: user.username,
      password: user.password,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function loginUser(username, password) {
  return axios({
    method: 'post',
    url: 'o/token/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, currently getting auth
    },
    params: {
      grant_type: 'password',
    },
    data: {
      username,
      password,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function logoutUser(token) {
  return axios({
    method: 'post',
    url: 'o/revoke_token/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // seems like this should need auth
    },
    params: {
      token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function activateAccount(id, token) {
  return axios({
    method: 'post',
    url: 'api/activate/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    params: {
      id,
      token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function sendActivationEmail(id) {
  return axios({
    method: 'post',
    url: 'api/send_activation/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    params: {
      id,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function sendPasswordResetEmail(email) {
  return axios({
    method: 'post',
    url: 'api/password_reset/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // don't need auth, not logged in
    },
    params: {
      email,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function changePassword(id, token, password) {
  return axios({
    method: 'post',
    url: 'api/change_password/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    params: {
      id,
    },
    data: {
      token,
      password,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function accountChangePassword(currentPassword, newPassword, token, uid) {
  const url = '/api/user/' + uid + '/password/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      old_password: currentPassword,
      password: newPassword,
    },
  });
}

function accountSettings(email, userName, firstName, lastName, token, uid) {
  const url = '/api/user/' + uid + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      username: userName,
      email,
      first_name: firstName,
      last_name: lastName,
    },
  });
}

function searchTeachers(query) {
  return axios({
    method: 'get',
    url: 'api/teacher_search/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    params: {
      query,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function searchTrainers(query) {
  return axios({
    method: 'get',
    url: 'api/trainer_search/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    params: {
      query,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function listTrainers() {
  return axios({
    method: 'get',
    url: 'api/trainer_list/',
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // dont need auth, not logged in
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export {
  getUser,
  getUserByEmail,
  getUserByUsername,
  getUserByUsernameDepth,
  loginUser,
  logoutUser,
  registerUser,
  activateAccount,
  sendActivationEmail,
  sendPasswordResetEmail,
  changePassword,
  searchTeachers,
  searchTrainers,
  listTrainers,
  accountChangePassword,
  accountSettings,
};
